export default __webpack_public_path__ + "static/4-9b7470e36b4f238e88bf177f63acc350.jpeg";